import { AppTour } from '../tour.model';

export const EXPENSE_CATEGORY_INTRO_TOUR: AppTour = {
  tourId: 'expense-category-intro-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'category-function-intro-tour',
      attachTo: { element: '#function-guide-17', on: 'right' },
      cancelIcon: {enabled: false},
      title: 'tour_category_intro_title',
      text: 'tour_category_intro_text',
       buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};


export const EXPENSE_CATEGORY_WIZARD_TOUR: AppTour = {

  tourId: 'expense-category-wizard-tour',
  showProgress: true,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'category-wizard-step1-tour',
      attachTo: { element: '#step-guide-1', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_category_wizard_step1_title',
      text: 'tour_category_wizard_step1_text',
       buttons: [
        { text: 'tour_label_skip', action: 'custom', className:"btn btn-primary-tertiary btn-primary-tertiary--sm", handlerKey: 'onSkipClick'},
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
     } 
   ]
};

export const EXPENSE_CATEGORY_ADD_BUTTON_TOUR: AppTour = {

  tourId: 'expense-category-add-button-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true,classes: 'tooltip-guide' },
  steps: [
    {
      id: 'expense-category-add-button-tour',
      attachTo: { element: '#btn-add-category-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_category_list_title',
      text: 'tour_category_list_text',
      parallel: true
     }
   ]
};

export const EXPENSE_CATEGORY_ADD_MORE_BUTTON_TOUR: AppTour = {

  tourId: 'expense-category-add-more-button-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true,classes: 'tooltip-guide' },
  steps: [
    {
      id: 'expense-category-add-more-button-tour',
      attachTo: { element: '#btn-add-category-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      text: 'tour_expense_category_add_more_text',
      parallel: true
     }
   ]
};

export const ADD_CATEGORY_PANEL_TOUR: AppTour = {
  tourId: 'add-category-panel-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide'},
  steps: [
    {
      id: 'add-category-control-intro',
      attachTo: { element: '.add-category-form-guide', on: 'left' },
      cancelIcon: {enabled: false},
      title: 'tour_category_add_title',
      text: 'tour_category_add_text',
      parallel: true
     }
   ]
};